import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import {
  BuildingOffice2Icon,
  ClockIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { useUserRecord } from "@/app/Users/Hooks/useUserRecord";
import { useUserActions } from "@/app/Users/Hooks/useUserActions";

export function UserRecordScreen() {
  const user = useUserRecord();
  const getActions = useUserActions();

  return (
    <RecordScreen
      tabParams={{ id: user.id }}
      title={user.name ?? "--"}
      actionsGroups={getActions(user)}
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/users/$id",
          params: (prev) => prev,
          Icon: DocumentTextIcon,
        },
        {
          name: "Organisations",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/users/$id/organisations",
          params: (prev) => prev,
          Icon: BuildingOffice2Icon,
        },
        {
          name: "Activity",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/users/$id/activity",
          params: (prev) => prev,
          Icon: ClockIcon,
        },
      ]}
    />
  );
}
